function hasFarsiCharacters(text) {
    // Define the regex pattern for Farsi characters
    var farsiPattern = /[\u0600-\u06FF\uFB8A\u067E\u0686\u06AF\u200C\u200F]+/;
  
    // Test if the text matches the pattern
    return farsiPattern.test(text);
  }
  export default hasFarsiCharacters;